import { createSelector } from 'reselect';
import { hasPermission } from 'utils/permissions';
import permissionConstants from 'xm-constants/permissions';
import {
  pruneItemsAndGroups,
  selectPermissions,
  selectFeatureToggleMap,
} from './util';

function getIncidentsNav(permissions, featureToggleMap) {
  const isDocumentLibraryEnabled =
    featureToggleMap?.DOCUMENT_LIBRARY === 'true';
  const isIncidentTypesEnabled = featureToggleMap?.INCIDENT_TYPES === 'true';
  const isIncidentTaskListsEnabled =
    featureToggleMap?.INCIDENT_TASK_LISTS === 'true';
  const isIncidentPlaybooksEnabled = featureToggleMap?.PLAYBOOKS_MVP === 'true';
  const canManageIncidentTypes = hasPermission(
    permissions,
    permissionConstants.ABILITY_ACT_MANAGE_INCIDENT_TYPES,
  );

  const navItemGroups = [];
  if (isIncidentTaskListsEnabled) {
    const items = [
      {
        id: 'NAV_INCIDENTS',
        to: 'incidents',
        selectorId: 'IncidentsPlace',
        exclude: ['incident-types', 'incident-task-lists', 'playbooks'],
      },
    ];
    const configurationItems = [];
    if (isIncidentPlaybooksEnabled) {
      configurationItems.push({
        id: 'NAV_PLAYBOOKS',
        to: 'incidents/playbooks',
        selectorId: 'IncidentPlaybooks',
      });
    }
    if (isDocumentLibraryEnabled) {
      configurationItems.push({
        id: 'NAV_DOCUMENT_LIBRARY',
        to: 'document-library',
        selectorId: 'DocumentLibraryPlace',
      });
    }
    if (isIncidentTypesEnabled && canManageIncidentTypes) {
      configurationItems.push({
        id: 'NAV_INCIDENT_TYPES',
        to: 'incidents/incident-types',
        selectorId: 'IncidentTypesPlace',
      });
    }
    configurationItems.push({
      id: 'NAV_INCIDENT_TASK_LISTS',
      to: 'incidents/incident-task-lists',
      selectorId: 'IncidentTaskLists',
    });
    navItemGroups.push({ id: 'NAV_MANAGE_INCIDENTS', items });
    navItemGroups.push({
      id: 'NAV_INCIDENTS_CONFIGURATION',
      items: configurationItems,
    });
  } else {
    const items = [
      {
        id: 'NAV_INCIDENTS',
        to: 'incidents',
        selectorId: 'IncidentsPlace',
        exclude: ['incident-types', 'incident-task-lists'],
      },
    ];

    if (isIncidentTypesEnabled && canManageIncidentTypes) {
      items.push({
        id: 'NAV_INCIDENT_TYPES',
        to: 'incidents/incident-types',
        selectorId: 'IncidentTypesPlace',
      });
    }

    navItemGroups.push({
      id: 'NAV_MANAGE_INCIDENTS',
      items,
    });
  }

  return pruneItemsAndGroups(navItemGroups, permissions);
}

export default createSelector(
  [selectPermissions, selectFeatureToggleMap],
  getIncidentsNav,
);
